module.exports = __webpack_public_path__ + "static/media/startseite_auf_ohne.f983e779.jpg";